<template>
  <div v-if="show" class="third-import-page">
    <van-nav-bar
      safe-area-inset-top
      placeholder
      fixed
      z-index="1003"
      class="nav-bar"
      :title="$t('thirdParty.label.importResume')"
      left-arrow
      @click-left="goBack"
    >
    </van-nav-bar>
    <ResumeForm
      class="import-form"
      ref="form"
      :formLine="formLine"
      :data="thirdPartyForm"
    />
    <div class="submit-btn">
      <van-button class="submit" :disabled="!canThirdPartyLogin" @click="isLogin ? handelImportResume() : onLoginBtnClick()">{{ $t('thirdParty.btn.import') }}</van-button>
    </div>
    <div class="forget-password">
      <a class="forget-password-link" :href="forgetPasswordUrl">{{ $t('login.common.btn.forgetPassword') }}</a>
    </div>
    <AIResumeParseLoadingDialog :isShow="showAIResumeParseDialog" isMobile/>
  </div>
</template>

<script>
import _ from 'lodash'
import ResumeForm from '@/components/mobile/resumeForm.vue'
import { mapActions, mapGetters } from 'vuex'
import {
  THIRD_PARTY_CHANNEL_TYPE_51, THIRD_PARTY_CHANNEL_TYPE_FACEBOOK,
  THIRD_PARTY_CHANNEL_TYPE_LINKEDIN, THIRD_PARTY_CHANNEL_TYPE_JOBSTREET,
  THIRD_PARTY_LOGIN_STATUS_MAPPING
} from '@/constant/thirdParty'
import { STEP_TYPE } from '@/constant/candidate'
import AIResumeParseLoadingDialog from '@/components/dialog/aiResumeParseLoadingDialog.vue'

export default {
  components: {
    AIResumeParseLoadingDialog,
    ResumeForm
  },
  props: {
    show: {
      type: Boolean,
      default: true
    },
    type: {
      type: String,
      default: ''
    },
    resumeEditorSetting: {
      default: () => { }
    },
    companyId: {
      default: null
    },
    jobId: {
      default: null
    }
  },
  data () {
    return {
      i18nPrefix: 'thirdParty',
      THIRD_PARTY_CHANNEL_TYPE_51,
      THIRD_PARTY_CHANNEL_TYPE_FACEBOOK,
      THIRD_PARTY_CHANNEL_TYPE_LINKEDIN,
      THIRD_PARTY_CHANNEL_TYPE_JOBSTREET,
      THIRD_PARTY_LOGIN_STATUS_MAPPING,
      thirdPartyTask: {
        thirdparty: null,
        taskId: null,
        status: null,
        times: 0
      },
      thirdPartyForm: {
        thirdparty: null,
        username: null,
        userpwd: null,
        login_verify: null,
        selectUrl: null
      },
      importResumeSelectFrom: {
        resumeList: [],
        selectUrl: null
      },
      forgetPasswordUrl: null,
      isLogin: false,
      canThirdPartyLogin: true,
      showAIResumeParseDialog: false
    }
  },
  computed: {
    ...mapGetters('company', ['companyThemeSetting']),
    onlyUploadResume () {
      return this.$route.query.only_upload_resume === '1'
    },
    skipParseResume () {
      if (this.resumeEditorSetting?.skipParseResume) {
        return true
      }
      return false
    },
    useAIResumeParse () {
      return this.companyThemeSetting?.company.has_ai_resume_parse_premium
    },
    thirdPartySelect () {
      return [
        {
          name: '51job',
          label: this.$t(`${this.i18nPrefix}.label.job51Channel`),
          value: THIRD_PARTY_CHANNEL_TYPE_51,
          hidden: false
        },
        {
          name: 'jobstreet',
          label: this.$t(`${this.i18nPrefix}.label.jobStreetChannel`),
          value: THIRD_PARTY_CHANNEL_TYPE_JOBSTREET,
          hidden: false
        }
      ]
    },
    formLine () {
      const requiredMessage = this.$t('common.message.requiredFormField')
      const formLine = [
        {
          elType: 'select',
          name: 'thirdparty',
          options: {
            data: this.thirdPartySelect
          },
          handler: () => {
            this.forgetPasswordInit()
          },
          notSearch: true,
          label: this.$t(`${this.i18nPrefix}.label.signInWith`),
          rules: [{ required: true, message: requiredMessage, trigger: 'blur' }]
        },
        {
          elType: 'input',
          name: 'username',
          label: this.$t(`${this.i18nPrefix}.placeholder.account`),
          rules: [{ required: true, message: requiredMessage, trigger: 'blur' }]
        },
        {
          elType: 'input',
          name: 'userpwd',
          type: 'password',
          clearable: false,
          label: this.$t(`${this.i18nPrefix}.placeholder.password`),
          rules: [{ required: true, message: requiredMessage, trigger: 'blur' }]
        },
        {
          elType: 'select',
          name: 'selectUrl',
          hidden: !this.isLogin,
          options: {
            data: this.importResumeList
          },
          label: this.$t(`${this.i18nPrefix}.label.resume`),
          rules: [{ required: true, message: requiredMessage, trigger: 'blur' }]
        }
      ]
      return formLine
    },
    importResumeList () {
      const list = []
      const resumeFrom = this.importResumeSelectFrom.resumeList || []
      const cnName = this.$t(`${this.i18nPrefix}.label.resumeCnName`)
      const enName = this.$t(`${this.i18nPrefix}.label.resumeEnName`)
      _.forEach(resumeFrom, (item) => {
        if (item.cn_resume_url === item.en_resume_url) {
          list.push({
            label: item.resume_name,
            value: item.cn_resume_url
          })
        } else {
          if (item.cn_resume_url) {
            list.push({
              label: item.resume_name + cnName,
              value: item.cn_resume_url
            })
          }
          if (item.en_resume_url) {
            list.push({
              label: item.resume_name + enName,
              value: item.en_resume_url
            })
          }
        }
      })
      return list
    }
  },
  created () {

  },
  mounted () {

  },
  methods: {
    ...mapActions('personal', ['getResumeFromThirdParty', 'checkLoginStatusForThirdParty', 'parseResumeFromThirdParty', 'getUrlToImportThirdPartyResume', 'getForgetPasswordUrlForThirdPartyLogin']),
    async forgetPasswordInit () {
      if (!this.thirdPartyForm.thirdparty || _.isEmpty(this.thirdPartyForm.thirdparty)) {
        return
      }
      this.$emit('load', true)
      try {
        const resp = await this.getForgetPasswordUrlForThirdPartyLogin({ type: this.thirdPartyForm.thirdparty })
        if (resp && resp.url) {
          this.forgetPasswordUrl = resp.url
        }
      } finally {
        this.$emit('load', false)
      }
    },
    async onLoginBtnClick () {
      const success = await this.$refs.form.submit()
      if (!success) {
        return
      }
      this.canThirdPartyLogin = false
      this.showThirdPartyLoading = true
      const resp = await this.getResumeFromThirdParty(this.thirdPartyForm)
      if (resp && resp.data) {
        if (resp.status === 'status') {
          this.thirdPartyTask.taskId = resp.data
          this.thirdPartyTask.status = resp.status
          this.thirdPartyTask.thirdparty = this.thirdPartyForm.thirdparty
          this.checkThirdPartyStatus()
        } else if (resp.status === 'failed' && resp.data?.errmsg) {
          if (THIRD_PARTY_LOGIN_STATUS_MAPPING[resp.data.errmsg]) {
            this.$toast({ message: this.$t(`${this.i18nPrefix}.message.${THIRD_PARTY_LOGIN_STATUS_MAPPING[resp.data.errmsg].i18nKey}`) })
          } else {
            this.$toast({ message: this.$t(`${this.i18nPrefix}.message.thirdPartyLoginError`) })
          }
          this.canThirdPartyLogin = true
          this.showThirdPartyLoading = false
        } else {
          this.$toast({ message: this.$t(`${this.i18nPrefix}.message.thirdPartyLoginError`) })
          this.canThirdPartyLogin = true
          this.showThirdPartyLoading = false
        }
      }
    },
    async handelImportResume () {
      const params = {
        thirdparty: this.thirdPartyForm.thirdparty,
        resume_url: this.thirdPartyForm.selectUrl,
        company_id: this.companyId,
        job_id: this.jobId
      }
      if (this.useAIResumeParse) {
        this.showAIResumeParseDialog = true
      } else {
        this.$emit('load', true)
      }
      try {
        const resp = await this.parseResumeFromThirdParty(params)
        if (resp) {
          if (resp.status === 'success') {
            const resumeData = resp.resume_data
            if (this.onlyUploadResume) {
              if (this.skipParseResume) {
                this.$emit('uploadResume', resumeData.resumePath, this.skipParseResume)
              } else {
                this.$emit('uploadResume', resumeData, this.skipParseResume)
              }
              return
            }
            this.uploadedResume = true
            this.$emit('change', resumeData)
            this.goBaseInfoPage()
          } else if (resp.status === 'failure') {
            this.$toast({ message: this.$t(`${this.i18nPrefix}.message.praseFailure`) })
          } else if (resp.status === 'expiration') {
            this.$toast({ message: this.$t(`${this.i18nPrefix}.message.loginExpiration`) })
            this.cleanThirdPartyStatusLoginStatus()
          }
        }
      } finally {
        if (this.useAIResumeParse) {
          this.showAIResumeParseDialog = false
        } else {
          this.$emit('load', false)
        }
      }
    },
    async checkThirdPartyStatus () {
      if (this.thirdPartyTask.thirdparty && this.thirdPartyTask.taskId) {
        this.thirdPartyTask.times++
        const resp = await this.checkLoginStatusForThirdParty({
          tid: this.thirdPartyTask.taskId,
          thirdparty: this.thirdPartyTask.thirdparty
        })
        if (resp && resp.status === 'status') {
          if (this.thirdPartyTask.times > 30) {
            this.cleanThirdPartyStatus()
            this.$toast({ message: this.$t(`${this.i18nPrefix}.message.loadResumeFailedLater`) })
            this.canThirdPartyLogin = true
            this.showThirdPartyLoading = false
            return
          }
          setTimeout(this.checkThirdPartyStatus, 1000)
        } else if (resp.status === 'failed' && resp.data?.errmsg) {
          if (THIRD_PARTY_LOGIN_STATUS_MAPPING[resp.data.errmsg]) {
            this.$toast({ message: this.$t(`${this.i18nPrefix}.message.${THIRD_PARTY_LOGIN_STATUS_MAPPING[resp.data.errmsg].i18nKey}`) })
          } else {
            this.$toast({ message: this.$t(`${this.i18nPrefix}.message.thirdPartyLoginError`) })
          }
          this.canThirdPartyLogin = true
          this.showThirdPartyLoading = false
        } else if (resp.status === 'ok' && resp.data) {
          const resumeList = resp.data
          if (resumeList && resumeList.length > 0) {
            this.importResumeSelectFrom.resumeList = resumeList
            const cnUrl = resumeList[0].cn_resume_url
            const enUrl = resumeList[0].en_resume_url
            this.importResumeSelectFrom.selectUrl = cnUrl || enUrl
            this.thirdPartyForm.selectUrl = cnUrl || enUrl
          }
          this.isLogin = true
          this.canThirdPartyLogin = true
          this.showThirdPartyLoading = false
        }
      }
    },
    cleanThirdPartyStatus () {
      this.thirdPartyTask.taskId = null
      this.thirdPartyTask.status = ''
      this.thirdPartyTask.times = 0
      this.showThirdPartyLoading = false
      this.canThirdPartyLogin = true
    },
    cleanThirdPartyStatusLoginStatus () {
      this.importResumeSelectFrom = {
        resumeList: [],
        selectUrl: null
      }
      this.isLogin = false
    },
    handelThirdpartyChannelChange () {
      this.thirdPartyForm.username = ''
      this.thirdPartyForm.userpwd = ''
      this.thirdPartyForm.selectUrl = null
    },
    goBack () {
      this.$emit('goBack')
    },
    goBaseInfoPage () {
      this.goBack()
      this.$router.push({
        query: {
          ...this.$route.query,
          step: STEP_TYPE.BASE_INFO
        }
      })
    }
  },
  watch: {
    show: {
      handler () {
        this.thirdPartyForm.thirdparty = this.type
        this.forgetPasswordInit()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.third-import-page {

  .nav-bar {
    ::v-deep {
      .van-nav-bar__left {
        .van-icon {
          color: #686868;
        }
      }

      .van-nav-bar__title {
          font-size: 18px;
          line-height: 22px;
          color: #303133;
        }

      .van-nav-bar__content {
        height: 50px;
        border-bottom: 1px solid #DCDFE6;
      }

      .van-button--info {
        color: var(--custom-color, #0096cc);
        background-color: var(--custom-color, #0096cc);
      }
    }
  }

  .import-form {
    padding: 14px 18px;
    margin-top: 16px;
  }

  .submit-btn {
    padding: 0 18px;
    margin-bottom: 18px;

    .submit {
      display: block;
      height: 36px;
      width: 100%;
      background: #fff;
      border-radius: 2px;
      font-size: 14px;
      color: var(--custom-color, #0096cc);
      border: var(--custom-color, #0096cc) 1px solid;

      ::v-deep {
        .van-button__text {
          line-height: 34px;
        }
      }
    }
  }

  .forget-password {
    text-align: center;

    .forget-password-link {
      display: inline-block;
      color: var(--custom-color, #0096cc);
      font-size: 14px;

      &:hover {
        color: #717378;
        text-decoration: underline;
      }

      &:visited {
        color: #606266;
        text-decoration: underline;
      }
    }
  }
}
</style>
